import noop from '../../utils/noop';

export default function init(branchKey: string, callback: () => void = noop) {
  const branchUrl = 'https://cdn.branch.io/branch-latest.min.js';

  if (!branchKey) {
    return;
  }

  interface BranchWindow extends Window {
    [key: string]: any;
    branch?: {
      init: (key: string, callback: () => void) => void;
      setBranchViewData: (data: Record<string, any>) => void;
      _q: any[];
      logEvent: (eventName: string, customAttributes?: any) => void;
      disableTracking: (optOutOfBranch: boolean) => void;
      setIdentity: (id: string) => void;
      logout: () => void;
    };
  }

  (function (
    windowScope: BranchWindow,
    documentScope: Document,
    scriptTagName: string,
    globalObjectName: string,
    defineProxyMethod: (branch: any, method: string) => void,
    branchInstance: { _q: any[]; _v: number },
    methodNames: string[],
    loopIndex: number,
    newScriptElement?: HTMLScriptElement,
    referenceScriptElement?: HTMLScriptElement
  ) {
    if (!windowScope[globalObjectName] || !windowScope[globalObjectName]._q) {
      for (; loopIndex < methodNames.length; ) {
        defineProxyMethod(branchInstance, methodNames[loopIndex++]);
      }
      newScriptElement = documentScope.createElement(scriptTagName) as HTMLScriptElement;
      newScriptElement.async = true;
      newScriptElement.src = branchUrl;
      referenceScriptElement = documentScope.getElementsByTagName(
        scriptTagName
      )[0] as HTMLScriptElement;
      referenceScriptElement.parentNode?.insertBefore(newScriptElement, referenceScriptElement);
      windowScope[globalObjectName] = branchInstance;
      windowScope.branch?.init(branchKey, () => {
        if (callback) {
          callback();
        }
      });
      // According to branch docs: https://help.branch.io/faq/docs/en/force-a-journey-to-auto-open-the-app-for-users-that-have-it-installed
      // to achieve the desired behavior we need to setup this line
      // desired behavior:
      // Branch link will always open web
      // And web will always force the app opening if installed
      // if not then will remain in web.
      windowScope.branch?.setBranchViewData({
        $uri_redirect_mode: 1,
      });
    }
  })(
    (window as unknown) as BranchWindow,
    document,
    'script',
    'branch',
    function (b: any, r: any) {
      b[r] = function () {
        b._q.push([r, arguments]);
      };
    },
    { _q: [], _v: 1 },
    'addListener applyCode autoAppIndex banner closeBanner closeJourney creditHistory credits data deepview deepviewCta first getCode init link logout redeem referrals removeListener sendSMS setBranchViewData setIdentity track validateCode trackCommerceEvent logEvent disableTracking'.split(
      ' '
    ),
    0
  );
}
